module.exports = __webpack_public_path__ + "img/stock6.c07650e5.png";